import React from "react";
import "./valuableClients.css";

export default function ValuableClients() {
  const partners = [
    "https://tcsas.in/wp-content/uploads/2022/04/Rail-Wheel-Factory-Logo-300x274.gif",
    "https://tcsas.in/wp-content/uploads/2022/04/Amul_official_logo.svg-300x187.png",
    "https://tcsas.in/wp-content/uploads/2022/04/download-2-1.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/indian-railway-Copy-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/hal-Copy-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/defence-Copy-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/bp-Copy-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/bhel-Copy-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/bhartielec-Copy-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/Tata-Logo-Branding-in-Asia-300x158.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/MCF_Raebareli_Logo-300x300.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/drdo_logo-1-300x200.jpg",
    "https://tcsas.in/wp-content/uploads/2022/04/isro-300x300.png",
    "https://tcsas.in/wp-content/uploads/2022/04/indiannavi-Copy-300x300.png",
  ];

  return (
    <div className="valuable-clients-container">
      <h1>
        <span>Our Clients</span>
      </h1>

      {/* Intro Section */}
      <div className="valuable-clients-intro">
        <p>
          <strong style={{ color: "#0b5394" }}>
            Technocrat Aerospace & Defence Pvt. Ltd.
          </strong>{" "}
          proudly serves leading organizations across{" "}
          <strong>Government</strong>, <strong>Defence</strong>,{" "}
          <strong>Aerospace</strong>, <strong>Railways</strong>, and{" "}
          <strong>Critical Infrastructure</strong> sectors in India, along with
          strategic partners in the private sector.
        </p>

        <p>
          The following are selected clients and stakeholder organizations
          associated with our solutions and services:
        </p>

        <p>
          <strong>Technocrat Aerospace & Defence Pvt. Ltd.</strong> proudly
          serves a diverse and prestigious group of clients from across{" "}
          <strong>government</strong>, <strong>defence</strong>,{" "}
          <strong>aerospace</strong>, <strong>railways</strong>, and the{" "}
          <strong>private sector</strong>. Our valued clients include prominent
          organizations such as <strong>DRDO</strong>, <strong>HAL</strong>,{" "}
          <strong>Indian Air Force</strong>, <strong>Indian Navy</strong>,{" "}
          <strong>Indian Army</strong>, <strong>RDSO</strong>,{" "}
          <strong>ISRO</strong>, <strong>BEL</strong>, <strong>BHEL</strong>,{" "}
          <strong>NTPC</strong>, <strong>Tata Defence</strong>,{" "}
          <strong>Adani Defence</strong>, <strong>L&T Defence</strong>,{" "}
          <strong>AAI</strong>, <strong>AMUL</strong>,{" "}
          <strong>Modern Coach Factory</strong> Rae Bareli,{" "}
          <strong>Delhi Metro</strong>, and many others.
        </p>

        <p>
          We are committed to delivering{" "}
          <strong>high-quality aerospace and defence solutions</strong> tailored
          to the specific needs of our distinguished clients, supporting their{" "}
          <strong>mission-critical operations</strong> and{" "}
          <strong>technological advancements</strong>. This diverse client base
          reflects our <strong>expertise</strong> and{" "}
          <strong>strong partnerships</strong> across multiple key sectors in
          India.
        </p>
      </div>

      {/* Clients Logo Section */}
      <div className="valuable-clients-slider">
        <div className="slider-track">
          {partners.concat(partners).map((logo, index) => (
            <img
              key={index}
              src={logo}
              alt={`Partner ${index}`}
              className="valuable-client-logo"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
